import { Division } from '@la/types';

export const getNumberOfSpotsLeft = (
  division: Division
): number | undefined => {
  let numberOfSpotsLeft;
  if (division.maxNumberOfTeams) {
    if (division.numberOfRegisteredTeams) {
      numberOfSpotsLeft =
        division.maxNumberOfTeams - division.numberOfRegisteredTeams;
    } else {
      numberOfSpotsLeft = division.maxNumberOfTeams;
    }
  }

  return numberOfSpotsLeft;
};
